export function toCsvParam(value) {
  if (Array.isArray(value)) {
    const normalized = value.filter(Boolean).join(",");
    return normalized || undefined;
  }

  return value || undefined;
}

export function buildPaginationParams({ page, pageSize, ...params }) {
  return {
    limit: pageSize,
    offset: Math.max(page - 1, 0) * pageSize,
    ...params,
  };
}
